import { slugifyNavLabel } from '@/utils/i18n/navLabelSlug';

export function buildNavLabelTranslationKey(englishLabel: string): string {
  return `nav.label.${slugifyNavLabel(englishLabel)}`.slice(0, 80);
}
